import { algoliasearch, type SearchClient } from "algoliasearch";

const APP_ID = import.meta.env.VITE_ALGOLIA_APP_ID as string | undefined;
const SEARCH_KEY = import.meta.env.VITE_ALGOLIA_SEARCH_KEY as string | undefined;
const INDEX = (import.meta.env.VITE_ALGOLIA_INDEX as string | undefined) || "products";
const INDEX_PRICE_ASC = (import.meta.env.VITE_ALGOLIA_INDEX_PRICE_ASC as string | undefined) || INDEX;
const INDEX_PRICE_DESC = (import.meta.env.VITE_ALGOLIA_INDEX_PRICE_DESC as string | undefined) || INDEX;
const INDEX_NEWEST = (import.meta.env.VITE_ALGOLIA_INDEX_NEWEST as string | undefined) || INDEX;
const CREATORS_INDEX = (import.meta.env.VITE_ALGOLIA_CREATORS_INDEX as string | undefined) || "creators";

export const algoliaEnabled = !!(APP_ID && SEARCH_KEY);

let client: SearchClient | null = null;
export function getAlgolia(): SearchClient | null {
  if (!APP_ID || !SEARCH_KEY) return null;
  if (!client) client = algoliasearch(APP_ID, SEARCH_KEY);
  return client;
}

export function algoliaIndexForSort(sort: string): string {
  if (sort === "Price: Low") return INDEX_PRICE_ASC;
  if (sort === "Price: High") return INDEX_PRICE_DESC;
  if (sort === "Newest") return INDEX_NEWEST;
  return INDEX;
}

export async function algoliaSearch<T = Record<string, unknown>>(
  query: string,
  opts: { hitsPerPage?: number; filters?: string; facetFilters?: Array<string | string[]>; indexName?: string; page?: number } = {},
) {
  const c = getAlgolia();
  if (!c) return null;
  const res = await c.searchSingleIndex({
    indexName: opts.indexName ?? INDEX,
    searchParams: {
      query,
      hitsPerPage: opts.hitsPerPage ?? 24,
      filters: opts.filters,
      facetFilters: opts.facetFilters,
      page: opts.page,
    },
  });
  return {
    hits: res.hits as Array<T & { objectID: string }>,
    nbHits: res.nbHits,
    nbPages: res.nbPages,
    page: res.page,
  };
}

export async function algoliaSearchCreators<T = Record<string, unknown>>(query: string, hitsPerPage = 6) {
  const result = await algoliaSearch<T>(query, { hitsPerPage, indexName: CREATORS_INDEX });
  return result?.hits ?? null;
}
